var _circle, _path, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateGraspByHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 43.5,
    r: 32.5,
    fill: "#E0EBF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9876 29.0097C37.2314 28.8654 36.2024 30.3402 31.5878 33.1027C23.9334 37.6927 22.0434 36.453 19.1612 40.0491C13.2288 47.1558 16.0795 54.193 24.1014 57.5807C33.966 61.7913 44.9435 56.3304 48.1302 45.2055C48.7655 42.7635 50.1567 37.4255 47.0802 33.1561C46.2611 31.9859 45.2033 31.0096 43.9792 30.2939C42.7551 29.5783 41.3935 29.1402 39.9876 29.0097Z",
    fill: "#407DBB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 17.5,
    r: 17.5,
    fill: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4419 11.5833C66.8162 11.9566 67.0265 12.4628 67.0265 12.9906C67.0265 13.5184 66.8162 14.0246 66.4419 14.3979L59.0666 21.7498C58.7468 22.0684 58.3461 22.2944 57.9075 22.4037L55.6201 22.974C55.5364 22.9948 55.4488 22.9937 55.3657 22.9707C55.2826 22.9477 55.2069 22.9036 55.1459 22.8428C55.085 22.7819 55.0409 22.7064 55.018 22.6235C54.995 22.5406 54.994 22.4533 55.0151 22.3699L55.5861 20.0907C55.6959 19.653 55.923 19.2532 56.2431 18.9343L63.6174 11.5833C63.8028 11.3984 64.023 11.2517 64.2653 11.1516C64.5076 11.0515 64.7673 11 65.0296 11C65.2919 11 65.5516 11.0515 65.7939 11.1516C66.0363 11.2517 66.2564 11.3984 66.4419 11.5833V11.5833ZM62.9115 13.6932L56.95 19.6389C56.7582 19.8303 56.6223 20.0701 56.5566 20.3326L56.1862 21.8086L57.6658 21.4393C57.9293 21.3736 58.1698 21.2377 58.3617 21.0462L64.3242 15.1025L62.9125 13.6952L62.9115 13.6932ZM64.3242 12.2869L63.6174 12.9906L65.0291 14.3979L65.736 13.6942C65.9179 13.5065 66.0185 13.2551 66.0162 12.9942C66.0139 12.7332 65.9089 12.4836 65.7238 12.2991C65.5387 12.1145 65.2883 12.0099 65.0265 12.0076C64.7647 12.0053 64.5125 12.1056 64.3242 12.2869V12.2869Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGraspByHand);
export default __webpack_public_path__ + "static/media/create_grasp_by_hand.25f6e680d26de5dc7302b014d1de49fc.svg";
export { ForwardRef as ReactComponent };